<nav class="breadcrumb show-for-large">
  <div class="grid-container">
    <div class="grid-x">
      <div class="cell flex-container align-middle">
        <a routerLink="/" data-test="lmw-common-breadcrumb-home-link" >{{ homeText | async }}</a>
        <svg class="icon icon--chevrom-right">
          <use xlink:href="#icon-chevron-right" href="#icon-chevron-right"></use>
        </svg>
        <ng-container *ngFor="let link of urlNameAndSegments; last as isLast">
          <a *ngIf="!isLast" routerLink="/{{link.urlSegment}}"
            data-test="lmw-common-breadcrumb-link">{{link.urlName}}</a>
            <svg *ngIf="!isLast" class="icon icon--chevrom-right">
              <use xlink:href="#icon-chevron-right" href="#icon-chevron-right"></use>
            </svg>
          <span *ngIf="isLast" data-test="lmw-common-breadcrumb-link">{{link.urlName}}</span>
        </ng-container>
      </div>
    </div>
  </div>
</nav>
